const ONE_MIN_IN_MILLISECONDS = 60000;

export function datePickerUniversalDateFormat(date: Date) {
  // timezone offset meant that the date was being set to the day before when converted to utc via toISOString. This is a workaround.
  const tzOffset = date.getTimezoneOffset() * ONE_MIN_IN_MILLISECONDS; // getTimezoneOffset returns offset from UTC in mins
  const localISOTime = new Date(date.getTime() - tzOffset)
    .toISOString()
    .slice(0, -1);
  return `${localISOTime}Z`;
}
